<template>
  <div class="body">
    <div class="sec1Title">{{$t("leader_overview")}}</div>
    <div class="sec1c">
    <div class="sec1">
      <div style="margin-bottom: 24px">
        <div class="title">{{$t('signal_provider_address')}}</div>
        <div class="content">{{ trader }}</div>
      </div>
    </div>
    <div class="sec1">
      <div style="width: 30%">
        <div class="title">{{$t('settlement_currency')}}</div>
        <div class="content">{{ symbol }}</div>
      </div>
      <div style="width: 70%">
        <div class="title right">{{$t('settlementCurrencyAddress')}}</div>
        <div class="content right">{{ token }}</div>
      </div>
    </div>
    </div>
    <div class="sec1Title" style="margin-top: 18px">{{$t('project_performance')}}</div>
    <div class="sec2">
      <div>
        <div class="title">{{$t('unrealized_profit_loss')}}</div>
        <div :class="'value '+(profit>=0?'long':'short')">{{ profit }}({{profitRate}}%)</div>
      </div>
      <div>
        <div class="title right">{{$t('realized_profit_loss')}}</div>
        <div :class="'value right '+(totalProfit>0?'long':'short')">{{ totalProfit.toFixed(2) }}</div>
      </div>
    </div>
    <div class="sec3" >
      <div class="item" style="margin-top: 18px">
        <div class="title">{{$t('aum')}}</div>
        <div class="value right">{{ total }} {{ symbol }}</div>
      </div>
      <div class="item">
        <div class="title">{{$t('profit_sharing_ratio')}}</div>
        <div class="value right">{{ rate }}%</div>
      </div>
      <div class="item">
        <div class="title">{{$t('profit_received')}}</div>
        <div class="value right">{{ disProfit.toFixed(2) }} {{ symbol }}</div>
      </div>
    </div>
    <div class="sec1Title" style="margin-top: 18px">{{$t('account_amount')}}</div>
    <div class="sec4">
      <div>
        <div class="title">{{$t("available_balance")}}</div>
        <div class="num">{{balance}} {{symbol}}</div>
      </div>
      <div>
        <div class="title right">{{$t('shareValue')}}</div>
        <div class="num right">{{shareRate.toFixed(2)}}</div>
      </div>
    </div>
    <div class="detail" style="margin-top: 18px">
      <div class="left">{{$t("total_margin")}}</div>
      <div class="right">{{margin}}</div>
    </div>
    <div class="detail" style="margin-bottom: 150px;">
      <div class="left">{{$t("total_margin_ratio")}}</div>
      <div class="right">{{marginRate}}%</div>
    </div>

  </div>
</template>
<script>
import {isMobile, transBig2number, transNumber2Big} from "../utils/functions";
import * as echarts from "echarts";
import {createLeadingContractAndCall, createPerpOptionAndCall, getSelectTokenInfo} from "../utils/contract";
import {Method, Underling} from "../config/const";
import {BigNumber} from "ethers";
import {getLastPrice} from "../service/priceService";
import {getAssetInfo, getDisProfit, getHistoryData} from "../service/queryService";
import {nextTick} from "vue";
import {cacheData} from "../service/cacheService";

export default {
  props: {
    contractAddress: "",
    token: ""
  },
  data() {
    return {
      options: [
        {
          value: '1',
          label: this.$t('today')
        }, {
          value: '7',
          label: this.$t('one_week')
        }, {
          value: '15',
          label: this.$t('half_month')
        }, {
          value: '30',
          label: this.$t('thirty_days')
        }
      ],

      value: 7,
      symbol: "",
      trader:"",
      profit: 0,
      profitRate: 0,
      total: 0,
      rate: 0,
      balance: 0,
      shareRate: 0,
      margin: 0,
      marginRate: 0,
      totalProfit:0,
      disProfit:0,
      winPosition:0,
      totalPosition:0
    }
  },
  methods: {


    async getTokenInfo() {
      let tokenInfo = await getSelectTokenInfo(this.token);
      this.symbol = tokenInfo.symbol;
    },
    updatePan(value, total) {
      this.profit = Number(value.pan).toFixed(2);
      if (!value.pan) {
        this.profitRate = 0;
      } else if(Number(value.margin)>0){
        this.profitRate = parseFloat((parseFloat(value.pan) * 100 / parseFloat(value.margin)).toFixed(2))
      }

      if (!value.pan) {
        this.marginRate = 0;
      } else {
        if (Number(value.margin) === 0) {
          this.marginRate = 0;
        } else {
          this.marginRate = Number(value.marginRate)
        }
      }

      this.profitRate=this.shareRate==0?"--":this.profitRate;
      this.totalPosition = total;
    },
    async updateTrader(trader){
      this.trader=trader;
    },
    async getDisProfit(){
      let data=await getDisProfit(this.contractAddress.toLowerCase());
      if(!data.profitsDistributeds || data.profitsDistributeds.length==0){
        return ;
      }
      let total=BigNumber.from(0);
      for(let i in data.profitsDistributeds){
        let item=data.profitsDistributeds[i];
        total=total.add(BigNumber.from(item.paidDistribute))
      }
      this.disProfit=parseFloat(transBig2number(total));
    },
    async getProjectInfo() {


      let price = await getLastPrice()
      let priceBTC = transBig2number(price[Underling.BTC].price, price[Underling.BTC].decimal, 6);
      let priceETH = transBig2number(price[Underling.ETH].price, price[Underling.ETH].decimal, 6);

      let priceBtcNum = transNumber2Big(priceBTC);
      let priceEthNum = transNumber2Big(priceETH);
      let asset = await createLeadingContractAndCall(this.contractAddress, Method.getTotalBalance, [Underling.BTC, Underling.ETH], [priceBtcNum, priceEthNum]);

      let selectToken = await getSelectTokenInfo(this.token)

      this.symbol = selectToken.symbol
      let accountInfo = await createPerpOptionAndCall(selectToken.perpetual, Method.getAccountInfo,this.token, this.contractAddress);


      if (asset.gainLoss) {
        this.balance = transBig2number(accountInfo.availableAmount)
      } else {
        this.balance = transBig2number(accountInfo.availableAmount.sub(asset.profit))
      }
      this.total = transBig2number(asset.assetAmount);
      cacheData(this.token+"_total",this.total,5000);

      this.margin = transBig2number(accountInfo.marginAmount)

      let rate=await createLeadingContractAndCall(this.contractAddress,Method.commissionRate);
      this.rate = rate.toString();

      let totalShare = await createLeadingContractAndCall(this.contractAddress, Method.totalShare);


      if (totalShare.eq(BigNumber.from(0))) {
        this.shareRate = "0";
      } else {
        let shareValue = asset.assetAmount.mul(BigNumber.from(10000)).div(totalShare)
        this.shareRate = parseFloat(shareValue.toString()) / 10000;
      }

    },
    async getWinPosition(){
      let logs = await getHistoryData(this.contractAddress, 0);
      let winProfit = 0;
      let allProfit=0;
      for (let i in logs.orderHistories) {
        let item = logs.orderHistories[i];
        if (item.orderType == 3 || item.orderType == 4) {

          let profit=parseFloat(this.calcuRate(item));
          if(profit>0){
            winProfit+=profit;
          }
          allProfit+=profit;

        }
      }
      this.winPosition = winProfit.toFixed(2);
      this.totalProfit=allProfit;
      cacheData(this.token+"_allProfit",allProfit,5000);
    },
    calcuRate(order) {
      if (order.orderType == 1 || order.orderType == 2) {
        return "0";
      }

      let sub = BigNumber.from(0);
      if (order.direction == 1) {
        sub = BigNumber.from(order.price).sub(BigNumber.from(order.costPrice));
      } else {
        sub = BigNumber.from(order.costPrice).sub(BigNumber.from(order.price));
      }

      return transBig2number(sub.mul(order.amount).div(BigNumber.from("1000000000000000000")));
    },
    async getAssetInfo() {


      let assetInfo = [50, 50];

      assetInfo = await getAssetInfo(this.contractAddress, parseInt(this.value));

      let price = await getLastPrice();
      let btcPrice = transBig2number(price[Underling.BTC].price, price[Underling.BTC].decimal);
      let ethPrice = transBig2number(price[Underling.ETH].price, price[Underling.ETH].decimal);

      let btcValue = parseFloat(btcPrice) * parseFloat(assetInfo[0])
      let ethValue = parseFloat(ethPrice) * parseFloat(assetInfo[1])

      let rateBtc = 0;
      let rateEth = 0;
      if (btcValue !== 0 || ethValue !== 0) {
        rateBtc = parseFloat((btcValue / (btcValue + ethValue) * 100).toFixed(2));
        rateEth = parseFloat((100 - rateBtc).toFixed(2));
      }


    },
  },
  mounted() {
    this.getAssetInfo()
  },
  created() {
    this.getTokenInfo()
    this.getProjectInfo()
    this.getWinPosition()
    this.getDisProfit()
  }
}
</script>
<style lang="less" scoped>
.body {
  padding-left: 15px;
  padding-right: 15px;
}
.sec1c{
  height: 154px;
  background: rgba(16, 16, 20, 1);
  border-radius: 6px;
  padding-left: 20px;
  padding-top: 14px;
  padding-right: 20px;
}
.sec1Title{
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 23.17px;
  color: rgba(234, 236, 239, 1);
  margin-bottom: 12px;
}
.sec2Title{

}

.sec1 {
  display: flex;
  justify-content: space-between;

  .title {
    font-size: 14px !important;
    font-weight: 500;
    letter-spacing: -1px;
    line-height: 18.82px;
    color: rgba(90, 90, 93, 1) !important;
  }

  .content {
    font-size: 15px !important;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 15.24px;
    color: rgba(255, 255, 255, 1);
    margin-top: 11px;
    word-break: break-all;
  }

}

.right {
  text-align: right;
}

.sec2 {
  display: flex;
  height: 72px;
  border-radius: 6px;
  border: 0.55px solid rgba(56, 56, 56, 1);
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 14px;

  .title {
    font-size: 14px !important;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 15.93px;
    color: rgba(90, 90, 93, 1) !important;
  }

  .value {
    font-size: 15px !important;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 16.41px;
    color: rgba(46, 189, 133, 1);
    margin-top: 10px;
  }
  .long{
    color: rgba(46, 189, 133, 1) !important;
  }
  .short{
    color:rgba(239, 69, 74, 1) !important;
  }
}

.sec3 {
  .item {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;

    .title {
      font-size: 13px !important;
      font-weight: 500;
      letter-spacing: 0px;
      line-height: 14.06px;
      color: rgba(90, 90, 93, 1) !important;
    }

    .value {
      font-size: 13px;
      font-weight: 500;
      letter-spacing: 0px;
      line-height: 14.06px;
      color: rgba(234, 236, 239, 1);
    }
  }
}

.sec4 {
  .header {
    .title {
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 0px;
      line-height: 23.17px;
      color: rgba(234, 236, 239, 1);
    }
  }

  .mainpie_box {
    height: 100px;
  }

  .aaatext {
    font-size: 12px;
    font-weight: 500;;
    color: rgba(132, 142, 156, 1);
    margin-bottom: 200px;
  }
}
.sec4{
  height: 80px;
  border-radius: 6px;
  border: 0.55px solid rgba(56, 56, 56, 1);
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title{
    font-size: 14px !important;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 20.27px;
    color: rgba(90, 90, 93, 1);
    &.right{
      text-align: right;
    }
  }
  .num{
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 21.1px;
    color: rgba(234, 236, 239, 1);
    text-align: left;
    margin-top: 8px;
    &.right{
      text-align: right;
    }
  }
}
.detail{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  .left{
    font-size: 13px;
    font-weight: 500;
    letter-spacing: -1px;
    line-height: 18.82px;
    color: rgba(90, 90, 93, 1) !important;
    text-align: left;
  }
  .right{
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 15.24px;
    color: rgba(255, 255, 255, 1);
  }
}
.performance{
  margin-top: 39px;
  .header{
    .title{
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 0px;
      line-height: 23.17px;
      color: rgba(234, 236, 239, 1);
    }
  }
  .linChartShow2{
    height: 300px;
  }
  .profit_title{
    height: 32px;
    border-radius: 16px;
    background: rgba(56, 56, 56, 1);
    display: flex;
    align-items: center;
    padding-left: 1px;
    padding-right: 1px;
    margin-top: 10px;
    .profit_rate{
      height: 30px;
      border-radius: 15px;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0px;
      line-height: 30px;
      color: rgba(166, 166, 166, 1);
      flex: 1;
      text-align: center;
      &.active{
        background: rgba(22, 22, 22, 1);
      }
    }
  }
}
</style>
<style scoped lang="scss">
.el-select-dropdown__item {
  font-size: 12px;
}

.select_down {
  font-size: 12px;

  ::v-deep .el-input__suffix {
    .el-input__suffix-inner {
      .el-select__caret {
        font-family: 'element-icons' !important; // 确保使用 Element UI 的字体

        &.el-icon-arrow-up::before {
          content: "\e78f"; // 替换为你想用的 Element UI 图标的 Unicode 编码
        }

        &.el-icon-arrow-down::before {
          content: "\e790"; // 和展开时使用同一个图标的 Unicode
        }
      }
    }
  }
}
</style>